<div>
    <div class="panel mb-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <h5 class="text-lg font-semibold dark:text-white-light">Process Monitoring Checks Control Panel</h5>
        <div class="flex items-center gap-2">
            <label for="pmc-select" class="mb-0 text-sm font-semibold whitespace-nowrap">PMC:</label>
            <div class="w-full sm:w-64">
                <ng-select
                    id="pmc-select"
                    [(ngModel)]="selectedPmc"
                    [items]="pmcs"
                    bindLabel="name"
                    placeholder="Filter by PMC"
                    [clearable]="false"
                    (change)="onPmcChange()"
                >
                    <ng-template ng-option-tmp let-item="item">
                        <div>{{ item.name }}</div>
                        <small class="text-gray-500">{{ item.identification }}</small>
                    </ng-template>
                </ng-select>
            </div>
            <label for="duration-select" class="mb-0 text-sm font-semibold whitespace-nowrap">Duration:</label>
            <div class="w-full sm:w-40">
                <ng-select
                    id="duration-select"
                    [(ngModel)]="selectedDuration"
                    [items]="durationOptions"
                    placeholder="Last 7 days"
                    [clearable]="false"
                    (change)="onDurationChange()">

                    <ng-template ng-label-tmp let-item="item">
                        <div>Last {{ item }} days</div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        <div>Last {{ item }} days</div>
                    </ng-template>
                </ng-select>
            </div>
        </div>
    </div>

    <div class="mb-2 grid gap-6 xl:grid-cols-3">
        <div class="panel h-full xl:col-span-2">
            <div class="mb-5 flex flex-col md:flex-row md:items-center justify-between gap-4">
                <h5 class="text-lg font-semibold dark:text-white-light">Process Monitoring Checks Trend (Last {{ selectedDuration }} Days)</h5>
            </div>

            <div class="overflow-hidden">
                @if (!isLoading && dailyTrend && dailyTrend.series) {
                    <apx-chart
                        [series]="dailyTrend.series"
                        [chart]="dailyTrend.chart"
                        [dataLabels]="dailyTrend.dataLabels"
                        [stroke]="dailyTrend.stroke"
                        [colors]="dailyTrend.colors"
                        [markers]="dailyTrend.markers"
                        [labels]="dailyTrend.labels"
                        [responsive]="dailyTrend.responsive"
                        [xaxis]="dailyTrend.xaxis"
                        [yaxis]="dailyTrend.yaxis"
                        [fill]="dailyTrend.fill"
                        [plotOptions]="dailyTrend.plotOptions"
                        [legend]="dailyTrend.legend"
                        [grid]="dailyTrend.grid"
                        [annotations]="dailyTrend.annotations"
                        [tooltip]="dailyTrend.tooltip"
                        class="rounded-lg bg-white dark:bg-black"
                    >
                        <!-- loader -->
                        <div class="grid min-h-[175px] place-content-center bg-white-light/30 dark:bg-dark dark:bg-opacity-[0.08]">
                            <span class="inline-flex h-5 w-5 animate-spin rounded-full border-2 border-black !border-l-transparent dark:border-white"></span>
                        </div>
                    </apx-chart>
                }
            </div>
        </div>

        <div class="panel h-full xl:col-span-1">
            <div class="mb-5 flex items-center justify-between">
                <h5 class="text-lg font-semibold dark:text-white-light">Process Monitoring Checks Overview (Last {{ selectedDuration }} Days)</h5>
            </div>
            <div class="overflow-hidden">
                @if (!isLoading && salesByCategory && salesByCategory.series) {
                    <apx-chart
                        [series]="salesByCategory.series"
                        [chart]="salesByCategory.chart"
                        [dataLabels]="salesByCategory.dataLabels"
                        [stroke]="salesByCategory.stroke"
                        [colors]="salesByCategory.colors"
                        [legend]="salesByCategory.legend"
                        [plotOptions]="salesByCategory.plotOptions"
                        [labels]="salesByCategory.labels"
                        [states]="salesByCategory.states"
                        class="rounded-lg bg-white dark:bg-black"
                    >
                        <!-- loader -->
                        <div
                            class="grid min-h-[460px] place-content-center bg-white-light/30 dark:bg-dark dark:bg-opacity-[0.08]">
                        <span
                            class="inline-flex h-5 w-5 animate-spin rounded-full border-2 border-black !border-l-transparent dark:border-white"></span>
                        </div>
                    </apx-chart>
                }
            </div>
        </div>
    </div>
</div>
